import React from 'react';
import BannerSection from './sections/banner-section';
import ServiceSections from './sections/service-sections';
import TrustExpertsSection from './sections/trust-experts-section';
import AboutWeSection from './sections/about-we-section';
import HowWeWorksSection from './sections/how-we-works-section';
import BusinessPersonalSection from './sections/business-personal-section';
import PrioritizeSection from './sections/prioritize-section';
import ClientTestimonials from './sections/client-testimonials';
import MobileAppSection from './sections/mobile-app-section';
import ReviewSection from './sections/review-section';
import Header4 from '@/feature-module/common/header/header-4';
import MenuSection from './sections/menu-section';

const HomeThemeFour = (props: any) => {
  const { themeData, collections } = props;

  return (
    <>
      {/* <Header4 themeData={themeData} /> */}
      <div className="sec-home home_4_main_wrapper">
        <BannerSection themeData={themeData} />
        <ServiceSections themeData={themeData} />
        <MenuSection themeData={themeData} />        
        <TrustExpertsSection themeData={themeData} />
        <ReviewSection themeData={themeData} />
        <AboutWeSection themeData={themeData} />
        <HowWeWorksSection themeData={themeData} />
        <BusinessPersonalSection themeData={themeData} />
        <PrioritizeSection themeData={themeData} />
        <ClientTestimonials themeData={themeData} />
        <MobileAppSection themeData={themeData} />
      </div>
    </>
  );
};

export default HomeThemeFour;
